<template>
  <div class="workspace-specific-info-card">
    <tabs
      :tabs="tabs"
      :active-tab="activeTab"
      :tabs-styling="tabsStyling"
      :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false"
      @startTabChange="activeTab = $event"
    />
    <div
      v-if="tabs[activeTab].id === 'users'"
      :style="{ height: 'calc(100% - 80px)', 'margin-top': '21px' }"
    >
      <Table
        :checkbox="false"
        :tableLines="true"
        :loading="loading"
        :headers="usersHeaders"
        :items="users"
        :add-row-button="false"
        :action-buttons="false"
      />
    </div>
    <div
      v-if="tabs[activeTab].id === 'companies'"
      :style="{ height: 'calc(100% - 80px)', 'margin-top': '21px' }"
    >
      <Table
        :checkbox="false"
        :tableLines="true"
        :loading="loading"
        :headers="companiesHeaders"
        :items="companies"
        :add-row-button="false"
        :action-buttons="false"
      />
    </div>
    <div
      v-if="tabs[activeTab].id === 'map'"
      :style="{ height: 'calc(100% - 80px)' }"
    >
      <management-map
        :geo_json="textGeom"
        :drawable="editing"
        :showZoomButtons="true"
        :showCenterMapButton="true"
        :showRestartButton="editing"
        :showUploadGeomFromFileButton="editing"
        :showCoordinatesButton="editing"
        :style="{ height: 'calc(100% - 40px)' }"
        @update-map-data="$emit('update-map-data', $event)"
      ></management-map>
    </div>
  </div>
</template>

<script>
import Tabs from "@/newComponents/_Atoms/Tabs.vue";
import Table from "@/newComponents/_Molecules/Table";
import ManagementMap from "@/newComponents/_Molecules/ManagementMap.vue";
export default {
  name: "WorkspaceSpecificInfo",

  components: {
    Tabs,
    Table,
    ManagementMap,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },

    companies: {
      type: Array,
      required: true,
    },

    editing: {
      type: Boolean,
    },

    textGeom: {
      type: String,
    },
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        margin: "0px 0px 8px 0px",
        width: "100%",
        height: "39px",
      },
      tabsLabelsStyling: {
        "text-transform": "none",
        "font-size": "10px",
        "letter-spacing": "0",
      },
      loading: false,
    };
  },

  computed: {
    usersHeaders() {
      return [
        {
          text: this.$i18n.t("Name"),
          varName: "first_name",
          editable: false,
        },
        {
          text: this.$i18n.t("Username"),
          varName: "username",
          editable: false,
        },
        {
          text: this.$i18n.t("Email"),
          varName: "email",
          editable: false,
        },
      ];
    },

    companiesHeaders() {
      return [
        {
          text: this.$i18n.t("Name"),
          varName: "name",
          editable: false,
        },
      ];
    },

    tabs() {
      if (!this.editing) {
        return [
          {
            id: "map",
            label: this.$i18n.tc("Map", 2),
          },
          {
            id: "users",
            label: this.$i18n.tc("User", 2),
          },
          {
            id: "companies",
            label: this.$i18n.tc("Company", 2),
          },
        ];
      } else {
        this.activeTab = 0;
        return [
          {
            id: "map",
            label: this.$i18n.tc("Map", 2),
          },
        ];
      }
    },
  },
};
</script>

<style scoped>
.workspace-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
  max-height: 71%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/Directory/WorkspaceSpecificInfo.vue